import { render, staticRenderFns } from "./vehicleType.vue?vue&type=template&id=5aeef85c&scoped=true&"
import script from "./vehicleType.vue?vue&type=script&lang=js&"
export * from "./vehicleType.vue?vue&type=script&lang=js&"
import style0 from "./vehicleType.vue?vue&type=style&index=0&id=5aeef85c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aeef85c",
  null
  
)

export default component.exports